<template>
  <div class="page">
    <div class="page__container">
      <slot name="header" />
      <div class="page__main">
        <div class="page__sidebar">
          <slot name="sidebar" />
        </div>
        <div class="page__content">
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {};
</script>
<style lang="scss" scoped>
a {
  color: unset;
  text-decoration: unset;
  &:hover {
    color: #024089;
    text-decoration: unset;
  }
}
$sidebar-width: 211px;
.page {
  width: 100%;
  display: flex;
  justify-content: center;
  &__container {
    min-width: 1170px;
    max-width: 1170px;
    h2 {
      margin: 80px 0px;
      text-align: left;
    }
  }
  &__main {
    display: flex;
  }
  &__sidebar {
    background: #024089;
    width: $sidebar-width;
    color: white;
    padding: 68px 15px 20px;
  }
  &__content {
    width: calc(100% - $sidebar-width);
    background: #f8f8f8;
    color: #000000;
    padding: 48px;
  }
}
</style>